export const CANONICAL_WEB_APP_ORIGIN = "https://app.fintheon.io";
export const DESKTOP_DOWNLOAD_PATH = "/download";
export const WEB_AUTH_CALLBACK_PATH = "/auth/callback";

export function buildCanonicalWebAuthCallbackUrl(returnUrl?: string | null) {
  const url = new URL(WEB_AUTH_CALLBACK_PATH, CANONICAL_WEB_APP_ORIGIN);
  const returnPath = toSafeReturnPath(returnUrl);
  if (returnPath) url.searchParams.set("return_to", returnPath);
  return url.toString();
}

export function resolveWebAuthReturnPath(rawValue?: string | null): string {
  return toSafeReturnPath(rawValue) ?? "/";
}

export function isWebAuthCallbackPath(pathname?: string): boolean {
  const currentPath = pathname ?? window.location.pathname;
  return currentPath === WEB_AUTH_CALLBACK_PATH;
}

export function isWebAuthSessionPayloadPath(
  location: Pick<Location, "pathname"> = window.location,
): boolean {
  return location.pathname === WEB_AUTH_CALLBACK_PATH;
}

export function isDesktopDownloadEntry(
  location: Pick<Location, "hostname" | "pathname"> = window.location,
): boolean {
  if (location.pathname !== DESKTOP_DOWNLOAD_PATH) return false;
  return (
    location.hostname === "app.fintheon.io" ||
    location.hostname === "localhost" ||
    location.hostname === "127.0.0.1"
  );
}

export function currentWebAuthReturnPath(
  fallbackReturnUrl?: string | null,
): string | null {
  return fallbackReturnUrl ?? null;
}

function toSafeReturnPath(rawValue?: string | null): string | null {
  if (!rawValue) return null;

  try {
    const url = new URL(rawValue, CANONICAL_WEB_APP_ORIGIN);
    if (url.protocol !== "http:" && url.protocol !== "https:") return null;
    if (url.pathname === WEB_AUTH_CALLBACK_PATH) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}
